// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scope-procedure {
  min-height: 50px;
  max-width: max-content;
  font-size: x-large;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Docs/router/screens/Index/components/RPCDetail/components/ScopeProcedure.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".scope-procedure {\n  min-height: 50px;\n  max-width: max-content;\n  font-size: x-large;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
